<script>
  import { page } from '$app/stores';

  import SubMenu from './sub-menu.svelte';
  import menus from '$lib/utils/menus.js';

  $: path = $page.url.pathname;
  $: pathGroup = path.slice(1).split('/');
</script>

<nav class="hidden md:flex space-x-0 lg:space-x-6">
  {#each menus as menu}
    {#if menu.children}
      <SubMenu submenu={menu} pathgroup={pathGroup} />
    {:else}
      <a href={menu.url} class="ti-menu p-2 inline-flex items-center text-base font-medium hover:text-orange-400" class:ti-menu-checked={pathGroup.indexOf(menu.key) !== -1 || (path == '/' && menu.key === 'index')}>
        {menu.name}
      </a>
    {/if}
  {/each}
</nav>
